/*** IMPORTS FROM imports-loader ***/
var define = false;

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export function marqueeText() {
  function initMarquee(marqueeEl, { speed = 100 } = {}) {
    const inner = marqueeEl.querySelector(".marquee__inner");
    const item = inner.querySelector(".marquee__text");
    const vw = marqueeEl.offsetWidth;

    // 1) Clone until inner ≥ 2× viewport width
    while (inner.scrollWidth < vw * 2) {
      inner.appendChild(item.cloneNode(true));
    }

    // 2) Calculate one "cycle" = half of that total width
    const cycleWidth = inner.scrollWidth / 2;
    const cycleDuration = cycleWidth / speed;

    // 3) Create the tween but don't start it yet
    const tween = gsap.to(inner, {
      x: -cycleWidth,
      duration: cycleDuration,
      ease: "none",
      repeat: -1,
      paused: true, // Start paused
      onRepeat: () => gsap.set(inner, { x: 0 })
    });

    // 4) Use ScrollTrigger to start/stop the animation
    ScrollTrigger.create({
      trigger: marqueeEl,
      scroller: '.fullView',
      start: "top bottom", // When top of element hits bottom of viewport
      end: "bottom top",   // When bottom of element hits top of viewport
      onEnter: () => tween.play(),
      onLeave: () => tween.pause(),
      onEnterBack: () => tween.play(),
      onLeaveBack: () => tween.pause(),
    });

    // 5) (Optional) Pause on hover
    marqueeEl.addEventListener("mouseleave", () => {
      // Only resume if the element is in view
      const trigger = ScrollTrigger.getById(marqueeEl);
      if (trigger && trigger.isActive) {
        tween.play();
      }
    });
  }

  // Initialize every .marquee on the page
  document.querySelectorAll(".marquee").forEach(el =>
    initMarquee(el, { speed: 100 })
  );
}
